import { Card } from "@mui/material";
import React from "react";

const ViewNotifications = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
      }}
      className="flex-row align-items-center justify-content-center"
    >
      <Card
        sx={{
          padding: "2rem",
        }}
      >
        No Notifications
      </Card>
    </div>
  );
};

export default ViewNotifications;
